/**
 *  Animation main navigation Levle 1- > level 2
 *  @author Livescore <jsmith@example.com>
 *  @copyright 2025 livescore
 */
import {
    style, animate, transition, trigger,
} from '@angular/animations';

export const ENTERLEAVE = trigger('enter-leave', [
    transition(':enter', [

        style({ transform: 'translateX(-100%)', height: '*', opacity: 0 }),
        animate('800ms  ease-in', style({ transform: 'translateX(0%)', opacity: 1 })),


    ]),
    transition(':leave', [

        style({ transform: 'translateX(0%)', height: '*', opacity: 1 }),
        animate('500ms ease-in', style({ transform: 'translateX(-100%)' })),


    ]),

]);


// export const ENTERLEAVE = trigger('enter-leave', [
//     transition(':enter', [
//         // 1. Set position absolute *initially* so it doesn't affect layout
//         style({ width: '100%', transform: 'translateX(-100%)', opacity: 0 }),
//         animate('4000ms 2000ms ease-in', style({ transform: 'translateX(0%)', opacity: 1 })),
//         // Optional: When done, let Angular remove the element from the list
//     ]),
//     transition(':leave', [
//         // 2. Set position absolute *right away* to stop affecting layout
//         style({ width: '100%', transform: 'translateX(0%)', opacity: 1 }),
//         animate('2000ms ease-in', style({ transform: 'translateX(-100%)' })),
//     ]),
// ]);
